const TextFormat = {
  install (Vue) {
    Vue.prototype.$textFormat = {
      rawText (value) {
        let el = document.createElement('div')
        el.innerText = value
        return el.innerHTML
      }
    }
  }
}
export default TextFormat



// WEBPACK FOOTER //
// ./client/plugins/textformat.js